import { Config } from '../config';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PushSubscriptionService {
    private subscription: any;

    constructor(private http: HttpClient) {
    }

    setSubscription(subscription: any) {
        this.subscription = subscription;

        return this.http.post(`${Config.baseUrl}/notification/subscribe`, { subscription: this.subscription }).subscribe();
    }

    unsubscribe(subscription: any) {
        this.subscription = subscription;

        return this.http.post(`${Config.baseUrl}/notification/unsubscribe`, { subscription: this.subscription }).subscribe();
    }

    toggle(enable: boolean) {
        return this.http.post(`${Config.baseUrl}/notification/toggle`, { enable });
    }
}
